import { render, staticRenderFns } from "./MessageComposer.vue?vue&type=template&id=3de1e51f&scoped=true&"
import script from "./MessageComposer.vue?vue&type=script&lang=js&"
export * from "./MessageComposer.vue?vue&type=script&lang=js&"
import style0 from "./MessageComposer.vue?vue&type=style&index=0&id=3de1e51f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de1e51f",
  null
  
)

export default component.exports